/**
 * Resolves a place ID from accommodation placeReference field variants.
 * @param {string|{ placeId?: string }|null|undefined} placeReference
 * @returns {string|null}
 */
export function resolvePlaceIdFromReference(placeReference) {
  if (!placeReference) {
    return null;
  }
  if (typeof placeReference === 'string') {
    return placeReference;
  }
  return placeReference.placeId || null;
}

/**
 * Builds a normalised ACCOMMODATION_PLACE_UNLINKED event payload.
 * @param {Object} params
 * @param {string} params.userId
 * @param {string} params.tripId
 * @param {string} params.accommodationId
 * @param {string|Object|null} params.oldPlaceReference
 * @param {string} [params.reason]
 * @returns {Object}
 */
export function buildAccommodationPlaceUnlinkedPayload({
  userId,
  tripId,
  accommodationId,
  oldPlaceReference,
  reason
}) {
  const placeId = resolvePlaceIdFromReference(oldPlaceReference);
  return {
    userId,
    tripId,
    id: accommodationId,
    accommodationId,
    placeId,
    oldPlaceReference,
    reason: reason || null,
    timestamp: new Date().toISOString()
  };
}
